$(document).ready(function(){
    $(".js-up").on("click", function () {
        var body = $("html, body");
        body.stop().animate({scrollTop: 0}, 1500, 'swing');
    });
    $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();
        if (scroll > 900) {
            $(".js-up").addClass("visible");
        } else {
            $(".js-up").removeClass("visible");
        }
    });
    //front slider

    if ( $('.js-frontSlider').length) {
       $('.js-frontSlider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: true,
            mobileFirst: true,
            fade: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 8000,
            infinite: true,
            //waitForAnimate: true,
            //speed: 1000,
        });
    }


    //animations on scroll
    AOS.init();
    window.addEventListener('load', function() {
        AOS.refresh();
    });

    // instagram
    $(window).on('load', function(){
        
        
      });

      //scrolled top

        $(window).scroll(function(){
            if ($(window).scrollTop() > 0){
                $('.top').addClass('top--scrolled');
                $('.main__sidebar').addClass('main__sidebar--scrolled');
            } else {
                if ($(window).width()>1240){
                    $('.top').removeClass('top--scrolled');
                }
                $('.main__sidebar').removeClass('main__sidebar--scrolled');
            }
            

        });

        if ($(window).width()<1240){
            $('.top').addClass('top--scrolled');
            $('.main__sidebar').addClass('main__sidebar--scrolled');
        } else {
            $('.top').removeClass('top--scrolled');
            $('.main__sidebar').removeClass('main__sidebar--scrolled');
        }

        $( window ).resize(function() {
            if ($(window).width()<1240){
                $('.top').addClass('top--scrolled');
            } else {
                $('.top').removeClass('top--scrolled');
            }
        });
    //content slider
    
    if ( $('.js-contentSlider,.js-contentSlider-2').length) {
        $('.js-contentSlider').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: false,
             dots: true,
             draggable: true,
             mobileFirst: true,
             fade: true,
             autoplay: true,
             speed: 1000
         });
     }

     // text slider
     if ( $('.js-qouteSlider').length) {
        $('.js-qouteSlider').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: false,
             dots: true,
             draggable: true,
             mobileFirst: true,
             fade: true,
             autoplay: true,
             speed: 1000
         });
     }
     
     //sidebar
     $('.js-main__sidebar-icon').on('click', function(){
         $(this).closest('.main__sidebar').toggleClass('main__sidebar--open');
     });

     //gallerySLider
     $('.js-gallerySlider').slick({
        dots: true,
        slidesPerRow: 4,
        rows: 2,
        fade: true,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesPerRow: 3,
            rows: 2,
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesPerRow: 2,
            rows: 2,
          }
        }
      ]
    });

    //set date 
    var now = new Date();
    var tomorrow = new Date();

    var day = ("0" + now.getDate()).slice(-2);
    var month = ("0" + (now.getMonth() + 1)).slice(-2);
    
    var today = now.getFullYear()+"-"+(month)+"-"+(day) ;

    tomorrow.setDate(tomorrow.getDate() + 1);
    var day2 = ("0" + tomorrow.getDate()).slice(-2);
    var month2 = ("0" + (tomorrow.getMonth() + 1)).slice(-2);
    var nextDay = tomorrow.getFullYear()+"-"+(month2)+"-"+(day2) ;
    console.log(tomorrow);

    $('#date1').val(today);
    $('#date2').val(nextDay);
    

    // if ($(window).width()>980) {
    //     $.instagramFeed({
    //         'username': 'hotel_focus_ck',
    //         'container': ".instagram__widget",
    //         'items': 5,
    //         'margin': 0,
    //         'items_per_row': 5,
    //         'display_profile': false,
    //         'display_biography': false,
      
    //       });
    // } else {
    //     $.instagramFeed({
    //         'username': 'hotel_focus_ck',
    //         'container': ".instagram__widget",
    //         'items': 6,
    //         'margin': 0,
    //         'items_per_row': 6,
    //         'display_profile': false,
    //         'display_biography': false,
      
    //       });
    // }
  
});